import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {SaleProductModel} from '../../../api/entity/saleProduct.model';
import {SaleProductConverter} from '../../../api/converter/saleProduct.converter';


@Injectable({providedIn: 'root'})
export class SaleProductDataService extends AbstractDataServiceV2<SaleProductModel,
    SaleProductConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: SaleProductConverter) {
        super('SaleProduct', http, httpUrlGenerator, logger, config, converter);
    }
}
